import ApiService from './api.service';
import Config from '../services/config.service';
export default class ResourceService {
  static async fetchResources(params) {
    const resources = await ApiService.get('/resources/resources', {
      params,
    });
    return resources;
  }

  static async findResource(resourceId) {
    const resource = await ApiService.get(`/resources/resources/${resourceId}`);
    resource.url = `${Config.RESOURCES_URL}${resource.url}`;
    return resource;
  }

  static async findDocument(documentId) {
    const document = await ApiService.get(`/resources/documents/${documentId}`);
    document.url = `${Config.RESOURCES_URL}${document.url}`;
    return document;
  }

  static async deleteResource(resourceId) {
    return ApiService.delete(`/resources/resources/${resourceId}`);
  }

  static async createResource(resource) {
    return ApiService.post('/resources/resources', resource);
  }

  static async updateResource({ id, resourceData, files }) {
    return ApiService.put(`/resources/resources/${id}`, {
      resourceData,
      files,
    });
  }
}
